import React from 'react'
import { useTranslation } from 'react-i18next'
import { tr } from 'i18n'
import { StatusBadge } from 'components/Erp/Display'
import { isBusyDriver } from 'components/Erp/IntegrationTrip'
import DriverBlockReason from '../DriverBlockReason/DriverBlockReason.tsx'
import './DriverStatus.scss'

type DriverStatusData = {
  status?: string | null
  status_display?: string | null
  blocked_reason?: string | null
}

export default function DriverStatus({ driver }: { driver: DriverStatusData }) {
  useTranslation()
  const blocked = driver.status === 'Заблокирован' || driver.status === 'blocked'
  return <div className="driver-status">
    <StatusBadge tone={blocked ? 'danger' : isBusyDriver(driver.status) ? 'warning' : 'success'}>
      {tr(driver.status_display || driver.status || 'Свободен')}
    </StatusBadge>
    {blocked && <DriverBlockReason reason={driver.blocked_reason || ''} />}
  </div>
}
